export { default as describeAssignContactAction } from './describeAssignContactAction';
export { default as asAssignContactActionInput } from './asAssignContactActionInput';
export { default as asAssignContactActionProps } from './asAssignContactActionProps';
export { default as AssignContactActionComponent } from './AssignContactActionComponent';
export { default as defaultNewAssignContactActionProps } from './defaultNewAssignContactActionProps';
